import { css } from '@emotion/react';

import { SCROLL_UP } from '../../const';
import useTheme from '../../hooks/useTheme';
import publicPath from '../../utils/publicPath';

export default () => {
  const {
    screenSizes,
    typography,
    breakpoints,
    spacing,
    colors,
    heights,
    borderRadius,
  } = useTheme();

  return {
    hero: ({ mobile, desktop }, scrollDirection) => {
      return css`
        display: grid;
        align-items: end;
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        grid-template-rows: 70% 30%;
        align-items: center;
        background: url(${mobile.src}) 75% 0 no-repeat;
        background-size: cover;
        padding: 0 ${spacing.s};
        margin-top: ${scrollDirection === SCROLL_UP
          ? 0
          : heights.mainNav.mobile};

        &::before {
          content: '';
          position: absolute;
          top: 30vh;
          left: 0;
          width: 100%;
          height: 75%;
          background: linear-gradient(
              to bottom,
              rgba(0, 0, 0, 0) 20%,
              rgba(1, 30, 65) 75%,
              rgba(1, 30, 65) 100%
            )
            center 0 no-repeat;
          background-size: contain;
          z-index: 1;
        }

        ${breakpoints.m} {
          grid-template-rows: 60% 40%;
          align-items: center;
          background: url(${desktop.src}) 0 0 no-repeat,
            linear-gradient(
                to bottom,
                rgba(0, 0, 0, 0) 20%,
                rgba(1, 30, 65) 75%,
                rgba(1, 30, 65) 100%
              )
              0 0 no-repeat;
          background-size: cover, contain;
          margin-top: ${scrollDirection === SCROLL_UP
            ? 0
            : heights.mainNav.desktop};

          &::before {
            top: 10vh;
            left: 0;
            width: 100%;
            height: 100vh;
            background: linear-gradient(
                to bottom,
                rgba(0, 0, 0, 0) 20%,
                rgba(1, 30, 65) 75%,
                rgba(1, 30, 65) 100%
              )
              center 0 no-repeat;
            // will delete above once get confirmation from ollie
            background: linear-gradient(
                to bottom,
                rgba(0, 0, 0, 0) 5%,
                rgba(1, 30, 65) 58%,
                rgba(1, 30, 65) 100%
              )
              center 0 no-repeat;
            background-size: cover;
            z-index: 1;
            outline: 0;

            ${breakpoints.l} {
              height: 100vh;
              top: calc(100vh - 95vh);
            }
          }

          &::after {
            background: url(${publicPath(
                '/images/common/discover-football-watermark.svg'
              )})
              right center no-repeat;
          }
        }
      `;
    },
    textWrapper: hasLoaded => css`
      position: relative;
      z-index: 1;
      align-self: end;
      opacity: 0;
      transition: opacity 0.5s;
      width: 90vw;
      max-width: 390px;
      margin: 0 auto;

      ${hasLoaded &&
      css`
        opacity: 1;
      `}

      &.fadeOut {
        opacity: 0.3;
      }

      ${breakpoints.m} {
        max-width: ${screenSizes.xl};
      }
    `,
    mainText: css`
      ${typography.headings[3].mobile};
      text-transform: capitalize;
      z-index: 2;
      position: relative;
      color: ${colors.white};
      max-width: unset;
      transition: opacity 0.5s;
      text-align: center;
      margin: auto;

      &::after {
        content: '';
        position: absolute;
        left: 0;
        bottom: -15px;
        width: 70px;
        border-bottom: ${borderRadius.s} solid ${colors.red};
        left: Calc(100% - 61%);

        ${breakpoints.m} {
          left: Calc(100% - 53%);
        }
      }

      ${breakpoints.m} {
        ${typography.headings[1].desktop};
        max-width: 100%;
        font-family: FS Dillon;
        text-align: center;
        padding: 8rem 0 0.8rem 0;
      }

      ${breakpoints.l} {
        &::before {
          left: -8rem;
        }
      }
    `,
    imgWrapper: css`
      width: 100%;
      margin: 0 auto;
      display: grid;
      justify-content: center;
    `,
    image: category => css`
      width: ${category === 'Snickers Protein Just Play' ? '300px' : '100%'};
      height: 100%;
    `,
  };
};
